



















































































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import PaginateModel from "@/model/paginate";
import ContractMoveOut, {
  CONTRACT_STEP,
  ROLE_BY_STEP,
} from "@/model/contractMoveOut";
import contractMoveOutApi from "@/api/contractMoveOutApi";
import QTableHeader from "@/common/qTableHeader.vue";
import QPaginate from "@/common/qPaginate.vue";
import Company from "@/model/company";
import User, { USER_ROLE } from "@/model/user";
import QUserSelect from "@/common/qUserSelect.vue";
import QCalendar from "@/common/qCalendar.vue";
import qNotify from "@/common/qNotify";
import fileApi from "@/api/fileApi";
import moment from "moment";
import { DATETIME_FORMAT_FILE_NAME } from "@/common/constant";
import store from "@/store";
const routerStore = namespace("Router");
const auth = namespace("Auth");
@Component({
  name: "MovingList",
  components: {
    QTableHeader,
    QPaginate,
    QUserSelect,
    QCalendar,
  },
})
export default class MovingList extends Vue {
  @auth.Getter
  getCurrentyCompany!: Company;
  @auth.Getter
  getUserLogging!: User;
  @auth.Getter
  isManager!: boolean;
  @routerStore.Getter
  public getPreviousRouter;
  @routerStore.Getter
  public getSearchParameters;

  query: Record<string, never>;
  showPopup = false;
  public headers = [
    { id: "moving_out_date", name: "退去日", order: "" },
    { id: "desired_date", name: "退去立会日時" },
    { id: "", name: "契約者名" },
    { id: "", name: "物件" },
    { id: "step", name: "状況", order: "" },
    { id: "in_charge", name: "管理会社担当者", order: "" },
    { id: "witness_owner", name: "立会業者担当者", order: "" },
    { id: "property_owner", name: "物件オーナー", order: "" },
    { id: "", name: "各種書類" },
    { id: "", name: "" },
  ];
  public search: any = {};
  public dateConfig = {};
  public userRole = USER_ROLE;
  public contractorName = "";

  public stepGroup = {
    1: [4, 5, 6, 7, 8, 9, 10],
    2: [4, 5, 6, 7, 8, 9, 10],
    3: [6, 7, 8, 9, 10],
    4: [8, 9, 10],
    5: [9, 10],
  };

  public searchInital() {
    let defaultInchageId = "";
    if (this.isManager) {
      defaultInchageId = this.getUserLogging ? this.getUserLogging.id : "";
    }
    return {
      keyword: null,
      status: ["2"],
      move_out_date_from: null,
      move_out_date_to: null,
      in_charge_id: defaultInchageId,
      sort: "moving_out_date",
      direction: "desc",
    };
  }

  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public moveOuts: ContractMoveOut[] = null;
  get getPaginate() {
    return this.pagination;
  }

  get companyId() {
    return this.getCurrentyCompany.id;
  }

  mounted() {
    if( this.getPreviousRouter.matched[1] && this.getPreviousRouter.matched[1].name == "admin.contract-moving-router"
      && this.getSearchParameters && this.getSearchParameters.contractMovingList
    ) {
      this.search = this.getSearchParameters.contractMovingList;
    } else {
      this.initalSearch(null);
    }

    this.getList(this.search);
    // this.doSearch(this.search);
  }

  public async getList(query) {
    query = { ...query, ...this.query };
    const result = await contractMoveOutApi.index(query);
    this.pagination = result.paginate;
    this.moveOuts = result.list;
  }

  public clear() {
    this.search = this.searchInital();
    store.dispatch("Router/setSearchParameters", {contractMovingList: null});
    this.changeState();
    this.doSearch(this.search);
  }

  public doSearch(query: any): void {
    this.getList(query);
  }

  public onSearch(): void {
    store.dispatch("Router/setSearchParameters", {contractMovingList: {...this.search}});
    this.changeState();
    this.doSearch(this.search);
  }

  public changeState(): void {
    let { name, params, query } = this.$router.currentRoute;

    query = { ...query, ...this.search };

    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
  }

  public initalSearch(parameters: any): void {
    const query = parameters || this.$router.currentRoute.query;
    if (query.status && typeof query.status === "string") {
      query.status = [query.status];
    }
    this.search = {
      ...this.searchInital(),
      ...query,
    };

    if (Object.keys(query).length > 0) {
      store.dispatch("Router/setSearchParameters", {contractMovingList: this.search});
    } else {
      store.dispatch("Router/setSearchParameters", {contractMovingList: null});
    }
  }

  public inCharge(moveOut: ContractMoveOut) {
    if (moveOut.step >= CONTRACT_STEP.STEP_CREATE_REPORT_REPAIR) {
      return moveOut.report_in_charge_id === this.getUserLogging.id ? "on" : "";
    }
    return moveOut.in_charge_id === this.getUserLogging.id ? "on" : "";
  }

  public baton(moveOut: ContractMoveOut) {
    if (this.inCharge(moveOut) != "") {
      return "";
    }
    return ROLE_BY_STEP[moveOut.step].includes(
      this.getCurrentyCompany.pivot.role_id
    )
      ? "on"
      : "";
  }

  public currentStatus(fieldName, moveOut: ContractMoveOut) {
    return moveOut[fieldName] ? "on" : "";
  }

  public async download(fileName, moveOut: ContractMoveOut) {
    if (!moveOut[fileName]) {
      return;
    }
    const response = await fileApi.download(moveOut[fileName]);
    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement("a");

    fileLink.href = fileURL;
    fileLink.setAttribute(
      "download",
      this.$t(`download_files.${fileName}`, { filename: moment().format(DATETIME_FORMAT_FILE_NAME) }).toString()
    );
    // eslint-disable-next-line unicorn/prefer-dom-node-append
    document.body.appendChild(fileLink);
    fileLink.click();
    // eslint-disable-next-line unicorn/prefer-dom-node-remove
    document.body.removeChild(fileLink);
  }

  public goDetail(moveOut: ContractMoveOut) {
    this.contractorName = moveOut.manageInCharge ? moveOut.manageInCharge.username : "";
    if (moveOut.isTranfered) {
      qNotify.error({
        text: this.$t("data_was_transfered"),
      });
      return;
    }
    if (
      ROLE_BY_STEP[moveOut.step].length > 0 &&
      !ROLE_BY_STEP[moveOut.step].includes(
        this.getCurrentyCompany.pivot.role_id
      )
    ) {
      this.showPopup = true;
    } else {
      this.$router.push({
        name: "admin.contract-move-out-follow",
        params: {
          id: moveOut.id,
        },
      });
    }
  }
}
